<l-full-page-layout>
  <div class="container">
    <iframe src="https://godatahub.com/test_in_app_content" allowfullscreen></iframe>
  </div>
</l-full-page-layout>
